import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getLogsGatewayUrl } from '../base/url.logs.gateway';
import {
  FrontEventLogRequest,
  FrontEventLogResponse,
} from '../logging/front-event-log.types';

/** POST /api/logs/eventos — registro centralizado de eventos frontend. */
@Injectable({ providedIn: 'root' })
export class LogsEventosGatewayApi {
  constructor(private readonly http: HttpClient) {}

  postEvento(body: FrontEventLogRequest): Observable<FrontEventLogResponse> {
    return this.http.post<FrontEventLogResponse>(getLogsGatewayUrl(), body);
  }
}
